import styled from "styled-components";
import variables from "./variables";
import bgImg from "../../assets/media/revised/bgimage.png";
import bgImgmobile from "../../assets/media/revised/bgimage_m.png";

const { screen_md, screen_sm, font_family_en, font_family_th } = variables;

export const HeroDiv = styled.div`
	background-image: url(${bgImg});
	background-size: cover;
	background-position: center;
	position: relative;
	height: 638px;
	object-fit: contain;

	.slick-next {
		right: 10px !important;
	}
	.slick-prev {
		left: 10px !important;
	}
	.slick-next:before,
	.slick-prev:before {
		font-size: 80px;
		line-height: 1;
		opacity: 0.75;
		color: #fff;
		-webkit-font-smoothing: antialiased;
	}

	.slick-prev,
	.slick-next {
		width: 30px;
		height: 80px;
		bottom: unset;
		font-size: 0;
		line-height: 0;
		position: absolute;
		top: 50%;
		background-color: unset;
		padding: 0;
		-webkit-transform: translateY(-50%);
		-ms-transform: translateY(-50%);
		transform: translateY(-50%);
		cursor: pointer;
		border: none;
		z-index: 2;
	}

	@media (max-width: ${screen_md}) {
		height: 300px;
	}

	@media (max-width: ${screen_sm}) {
		background-image: url(${bgImgmobile});
		height: 410px;
		.slick-prev,
		.slick-next {
			top: unset;
			bottom: -40px;
		}
	}
`;

export const HeroContent = styled.div`
	@media (max-width: ${screen_sm}) {
		padding: 0 10px;
	}
`;

export const HeroContentTitle = styled.div`
	float: left;
	font-family: ${font_family_th};
	font-size: 50px;
	font-weight: 500;
	margin-top: 110px;
	margin-bottom: 23px;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.2;
	letter-spacing: normal;
	color: #ffffff;
	letter-spacing: 1.4px;

	${(props) =>
		props.lang === "en" &&
		`
        font-family: ${font_family_en};
    `}

	@media(max-width: ${screen_md}) {
		margin-top: 50px;
	}
`;

export const HeroContentTitle1 = styled.h2`
	margin: 0;
	font-size: 30px;

	@media (max-width: ${screen_md}) {
		font-size: 20px;
	}
`;
export const HeroContentTitle2 = styled.h2`
	margin: 0;
	font-size: 50px;

	@media (max-width: ${screen_md}) {
		font-size: 30px;
	}
`;
export const HeroContentTitle3 = styled.h2`
	margin: 0;
	font-size: 30px;

	@media (max-width: ${screen_md}) {
		font-size: 20px;
	}
`;

export const BtnHero = styled.a`
	border: 1px solid rgb(255, 255, 255);
	background-color: unset;
	color: rgb(255, 255, 255);
	display: inline-block;
	padding: 6px 12px;
	margin-bottom: 0;
	font-size: 14px;
	font-weight: 400;
	line-height: 1.42857143;
	text-align: center;
	white-space: nowrap;
	vertical-align: middle;
	-ms-touch-action: manipulation;
	touch-action: manipulation;
	cursor: pointer;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	background-image: none;
	border-radius: 4px;
`;

export const HeroImg = styled.div`
    float: left;
    margin-top: 130px;
    margin-left: 80px;

    @media(max-width: ${screen_md}) {
        display: none;
`;



// WEBPACK FOOTER //
// ./src/components/style/hero.jsx